import React from 'react'

class Layer extends React.Component {

    layer = undefined
    eventHandlers = undefined

    componentDidMount() {
        this.addLayer()
        this.afterAdd()
    }

    addLayer() {
        this.layer = this.createLayer()
        this.layer.addTo(this.props.map)
    }

    afterAdd() {}

    componentWillUnmount() {
        this.removeLayer()
        this.afterRemove()
    }

    removeLayer() {
        this.layer.removeFrom(this.props.map)
        this.layer = undefined
    }

    afterRemove() {}

    getEventHandlers() {
        return {}
    }

    render() {
        return null
    }

}

export default Layer



// WEBPACK FOOTER //
// ./src/components/Leaflet/Layer.js